import { ModalV2 } from "@/components";
import { InputAdornment, Paper, Stack, TextField, Typography } from "@mui/material";
import { ChangeEvent, FC, ReactElement, useState } from "react";

const SavingsCalculator: FC<SavingsCalculatorProps> = ({
  open,
  onClose,
  currentValue,
  currentDuty,
}): ReactElement => {
  const [declaredValue] = useState(currentValue);
  const [firstSaleValue, setFirstSaleValue] = useState(currentValue * 0.9); // Default to 90% of current value

  const currentDutyRate = currentDuty / currentValue;
  const newDuty = firstSaleValue * currentDutyRate;
  const savings = currentDuty - newDuty;

  const handleFirstSaleValueChange = (e: ChangeEvent<HTMLInputElement>) => {
    const value = parseFloat(e.target.value);
    if (!isNaN(value)) {
      setFirstSaleValue(value);
    }
  };

  return (
    <ModalV2
      show={open}
      setShow={onClose}
      buttonText={"Close"}
      hideCancelButton
      buttonAction={onClose}
      title="Savings Calculator"
      subTitle="Calculate the potential savings for a first sale"
    >
      <Stack spacing={3} sx={{ my: 2 }}>
        <Stack spacing={1}>
          <Typography variant="body2" fontWeight={500}>
            Current Declared Value
          </Typography>
          <TextField
            value={`$${declaredValue.toLocaleString()}`}
            InputProps={{
              readOnly: true,
              startAdornment: (
                <InputAdornment position="start">
                  <Typography variant="body1" fontWeight={500}>
                    $
                  </Typography>
                </InputAdornment>
              ),
            }}
          />
        </Stack>

        <Stack spacing={1}>
          <Typography variant="body2" fontWeight={500}>
            Estimated First Sale Value
          </Typography>
          <TextField
            value={firstSaleValue}
            onChange={handleFirstSaleValueChange}
            type="number"
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <Typography variant="body1" fontWeight={500}>
                    $
                  </Typography>
                </InputAdornment>
              ),
            }}
          />
        </Stack>

        <Stack direction="row" spacing={2}>
          <Stack spacing={1} sx={{ flex: 1 }}>
            <Typography variant="body2" fontWeight={500}>
              Current Duty
            </Typography>
            <TextField
              value={`$${currentDuty.toLocaleString()}`}
              InputProps={{
                readOnly: true,
                startAdornment: (
                  <InputAdornment position="start">
                    <Typography variant="body1" fontWeight={500}>
                      $
                    </Typography>
                  </InputAdornment>
                ),
              }}
            />
          </Stack>

          <Stack spacing={1} sx={{ flex: 1 }}>
            <Typography variant="body2" fontWeight={500}>
              New Duty
            </Typography>
            <TextField
              value={`$${newDuty.toLocaleString()}`}
              InputProps={{
                readOnly: true,
                startAdornment: (
                  <InputAdornment position="start">
                    <Typography variant="body1" fontWeight={500}>
                      $
                    </Typography>
                  </InputAdornment>
                ),
              }}
            />
          </Stack>
        </Stack>

        <Paper
          sx={{
            p: 3,
            backgroundColor: "rgba(25, 118, 210, 0.08)",
            borderRadius: "8px",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Typography variant="body2" fontWeight={500} color="primary">
            Projected Savings
          </Typography>
          <Typography variant="h4" fontWeight={700} color="primary">
            ${savings.toLocaleString()}
          </Typography>
        </Paper>
      </Stack>
    </ModalV2>
  );
};

export default SavingsCalculator;
